import { render } from "./DataManagers.vue?vue&type=template&id=9cc051de"
import script from "./DataManagers.vue?vue&type=script&lang=js"
export * from "./DataManagers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__